import InfoIcon from "@mui/icons-material/Info";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import classes from "../../../../components/DownloadReportButton/styles.module.css";

export const CompanionApp = () => {
	const { t, i18n } = useTranslation();
	const currentLang = i18n?.language || "pl";

	return (
		<>
			<Box sx={{ display: "flex", gap: "16px", p: 0 }}>
				<a
					className={classes.downloadLink}
					href="/CARGOseller_desktop.zip"
					download={true}
					style={{
						textDecoration: "none",
						textTransform: "uppercase",
					}}
				>
					{t("download_companion")}
				</a>
				<Button
					variant="contained"
					href={
						currentLang === "pl"
							? "https://drive.google.com/file/d/17Ks-XSCofD1koVszcBes5QlGzAButpTn/view?usp=drive_link"
							: "https://drive.google.com/file/d/1teJdWMVRDaaU7pXwGJw7qbqi00X7-ImN/view?usp=sharing"
					}
					target="_blank"
					rel="noreferrer"
					sx={{
						background: "#e0e0e0",
						color: "#121212",
						"&:hover": {
							background: "#c9c9c9",
						},
						display: "flex",
						alignItems: "center",
						gap: "4px",
					}}
				>
					<SlowMotionVideoIcon />
					{t("video_instruction_n_min", { value: 5 })}
				</Button>
			</Box>
			<Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: "8px" }}>
				<InfoIcon color="info" />
				<Typography variant="body2">{t("timocom_disclaimer")}</Typography>
			</Box>
		</>
	);
};
